// Shared status palette for referral cards/dropdowns.
// Native <option> elements only honour inline style, not Tailwind classes,
// so we drive both the trigger pill and the option list from this map.
export const statusStyleMap = {
  sent: { bg: "#dbeafe", fg: "#1e40af" },
  viewed: { bg: "#fef9c3", fg: "#854d0e" },
  contacted: { bg: "#f3e8ff", fg: "#6b21a8" },
  interested: { bg: "#dcfce7", fg: "#166534" },
  meeting_scheduled: { bg: "#cffafe", fg: "#155e75" },
  accepted: { bg: "#d1fae5", fg: "#065f46" },
  rejected: { bg: "#fee2e2", fg: "#991b1b" },
  not_interested: { bg: "#f3f4f6", fg: "#1f2937" },
};

export const clientStatusOptions = [
  { value: "sent", label: "Sent" },
  { value: "viewed", label: "Viewed" },
  { value: "contacted", label: "Contacted" },
  { value: "interested", label: "Interested" },
  { value: "meeting_scheduled", label: "Meeting Scheduled" },
  { value: "accepted", label: "Accepted" },
  { value: "rejected", label: "Rejected" },
  { value: "not_interested", label: "Not Interested" },
];
